import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import Grid from 'material-ui/Grid'
import Card from 'material-ui/Card'
import Button from 'material-ui/Button'
import Divider from 'material-ui/Divider'
import _ from 'lodash'

import { getTokens } from 'modules/users/current/tokens'
import { getPromoTokensBalance } from 'modules/users/current/promotokens/balance'
import UserBalances from './user_balances'
import parametersSelector from 'selectors/parameters'
import currentUserSelector from 'selectors/current_user'
import jsonSelector from 'selectors/json'

const coins_number_format = n => I18n.l(n)
// const percent_format = n => I18n.l(n) + '%'
const currency_format = (n, currency) =>
  `${I18n.l(n, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${currency}`
// const original_number_format = n => n

const Aside = ({
  user_signed_in,
  config_parameters,
  bonus_preference,
  user_totals,
  bonus_referral,
  promo_token_balance,
  raised,
  abilities
}) =>
  abilities.can_show_ico_info ? (
    <div>
      <UserBalances />
      <Grid container id="sidebar-coins-info">
        {user_signed_in &&
          !_.isEmpty(user_totals) && (
            <React.Fragment>
              <Grid item xs={12}>
                <h4>
                  {I18n.t('aside.token_balance_title', {
                    coin_name: config_parameters['coin.name'],
                    coin_tiker: config_parameters['coin.tiker']
                  })}
                </h4>
                <p>
                  {coins_number_format(
                    user_totals['coin_count'] + user_totals['tokens_details'].referral_user
                  )}
                </p>
              </Grid>
              <Grid item xs={12}>
                <Divider light />
              </Grid>

              {config_parameters['referral.enabled'] > 0 && (
                <React.Fragment>
                  <Grid item xs={12}>
                    <h4>
                      {I18n.t('aside.referral_token_balance_title', {
                        coin_name: config_parameters['coin.name'],
                        coin_tiker: config_parameters['coin.tiker']
                      })}
                    </h4>
                    <div className="notice">
                      <em>{I18n.t('aside.referral_token_ballance_notice')}</em>
                    </div>
                    <p>
                      {currency_format(
                        user_totals['tokens_details'].referral_bounty *
                          config_parameters['coin.rate'],
                        config_parameters['coin.rate_currency']
                      )}
                    </p>
                  </Grid>
                  <Grid item xs={12}>
                    <Divider light />
                  </Grid>
                </React.Fragment>
              )}

              {abilities.can_be_used_promo_token &&
                promo_token_balance > 0 && (
                  <React.Fragment>
                    <Grid item xs={12}>
                      <h4>{I18n.t('aside.promo_token_balance_title')}</h4>
                      <p>{promo_token_balance}</p>
                    </Grid>
                    <Grid item xs={12}>
                      <Divider light />
                    </Grid>
                  </React.Fragment>
                )}
            </React.Fragment>
          )}

        <Grid item xs={12}>
          <h4>
            {I18n.t('aside.token_price_title', {
              coin_name: config_parameters['coin.name'],
              coin_tiker: config_parameters['coin.tiker']
            })}
          </h4>
          <p>
            {currency_format(
              config_parameters['coin.rate'],
              config_parameters['coin.rate_currency']
            )}
          </p>
          {/* {config_parameters['referral.enabled'] > 0 &&
            bonus_referral > 0 && (
              <span>
                <span className="bonus">{percent_format(bonus_referral)} Bonus</span> referral's
                reward <br />
              </span>
            )} */}
          {/* {bonus_preference &&
            (bonus_preference.length === 1 &&
            _.first(bonus_preference)['min_investment_amount'] === 0 ? (
              <span className="bonus">
                {percent_format(_.first(bonus_preference)['bonus_percent'])} Bonus
              </span>
            ) : (
              _.map(bonus_preference, (bonus, index) => (
                <span key={index}>
                  <span className="bonus">{percent_format(bonus['bonus_percent'])} Bonus</span> for
                  purchase ≥ {original_number_format(bonus['min_investment_amount'])}{' '}
                  {config_parameters['coin.rate_currency']}
                  <br />
                </span>
              ))
            ))} */}
        </Grid>

        {(!config_parameters['system.skip_totals_block_date_to'] ||
          new Date().getTime() >= config_parameters['system.skip_totals_block_date_to']) && (
          <React.Fragment>
            <Grid item xs={12}>
              <Divider light />
            </Grid>
            <Grid item xs={12}>
              <h4
                dangerouslySetInnerHTML={{
                  __html: I18n.t('aside.raised_title_html', {
                    coin_currency: config_parameters['coin.rate_currency']
                  })
                }}
              />
              <p>{I18n.l(raised.tokens.amount)}</p>
            </Grid>
            <Grid item xs={12}>
              <h4
                dangerouslySetInnerHTML={{
                  __html: I18n.t('aside.tokens_distributed_title_html', {
                    coin_name: config_parameters['coin.name']
                  })
                }}
              />
              <p>{I18n.l(raised.total_tokens_amount)}</p>
            </Grid>
          </React.Fragment>
        )}
      </Grid>
    </div>
  ) : (
    <Grid container>
      {!user_signed_in && (
        <Grid item xs={12} hidden={{ xsDown: true }} key="bottom">
          <Card className="aside">
            <Link to="/users/sign_up">
              <Button raised color="accent" id="btn-danger-sidebar">
                sign up
              </Button>
            </Link>
          </Card>
        </Grid>
      )}
    </Grid>
  )

class AsideContainer extends Component {
  componentDidMount() {
    const { getTokens, getPromoTokensBalance, abilities, user_signed_in } = this.props
    if (user_signed_in) {
      getTokens()
      if (abilities.can_be_used_promo_token) {
        getPromoTokensBalance()
      }
    }
  }

  render() {
    return <Aside {...this.props} />
  }
}

const mapStateToProps = state => ({
  user_signed_in: !!state.users.authorization,
  config_parameters: parametersSelector(state),
  bonus_preference: parametersSelector(state).bonuses_percent,
  user_totals: jsonSelector('users.current.tokens')(state),
  bonus_referral: currentUserSelector(state).is_referral
    ? parametersSelector(state)['referral.percent_to_referral']
    : 0,
  promo_token_balance: state.users.current.promotokens.balance.json,
  raised: jsonSelector('infos.raised')(state),
  abilities: jsonSelector('infos.abilities')(state)
})

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getTokens, getPromoTokensBalance }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(AsideContainer)



// WEBPACK FOOTER //
// ./src/containers/pages/dashboard/aside.js